import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import CampaignsContent from "../components/CampaignsContent";
import { getNewCampaignUrl } from "../utils/navigation";

import Icons from "@/components/icons";
import ModernPageLayout from "@/components/layout/ModernPageLayout";
import { Button } from "@/components/ui/v2/button";
import { usePermissionMatrix } from "@/lib/hooks/usePermissionMatrix";
import { useSearchSearchParams } from "@/lib/hooks/useSearchSearchParams";
import { useSortSearchParams } from "@/lib/hooks/useSortSearchParams";

function CampaignsPage() {
  const { clientId } = useParams();
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString() as string;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { orderBy, descending } = useSortSearchParams();
  const {
    searchValue,
    debouncedSearchValue,
    setSearchValue,
  } = useSearchSearchParams();
  const { canCreate, canEdit } = usePermissionMatrix();

  const handleClick = () => {
    navigate(getNewCampaignUrl(clientId));
  };

  const createLabel = t("campaigns.createButton");

  const canManageCampaigns = canCreate("campaigns") || canEdit("campaigns");

  return (
    <ModernPageLayout
      title={t("common.campaigns")}
      subtitle={
        canManageCampaigns
          ? t(
            "campaigns.description",
            "Manage and review all your campaigns here. Create, search, and organize campaigns.",
          )
          : t(
            "campaigns.descriptionSpectator",
            "View and review all campaigns here.",
          )
      }
      actions={
        canCreate("campaigns") ? (
          <Button onClick={handleClick}>
            <Icons.AddIcon fontSize={20} />
            <span>{createLabel}</span>
          </Button>
        ) : null
      }
    >
      <CampaignsContent
        clientId={clientId}
        descending={descending}
        orderBy={orderBy}
        queryString={queryString}
        search={debouncedSearchValue ?? ""}
        searchValue={searchValue ?? ""}
        setSearch={setSearchValue}
      />
    </ModernPageLayout>
  );
}

export default CampaignsPage;
